import MyMultiSelectInput from 'components/MyMultiSelectInput/MyMultiSelectInput';
import PropertyDisplay from 'components/PropertyDisplay/PropertyDisplay';
import PropertyEdit from 'components/PropertyEdit/PropertyEdit';
import React, { useRef } from 'react';
import coalesceClassNames from 'utils/coalesceClassNames';
import { generateShortUuid } from 'utils/helpers';
import './PropertyEditMultiSelect.scss';

export type PropertyEditMultiSelectProps = {
    className?: string;
    value?: string[];
    label: string;
    hint?: string;
    onChange?: (val: string[], label?: string) => void;
    readonly?: boolean;
    disabled?: boolean;
    options?: { label: string; value: string }[];
    allowBlank?: boolean;
    autoFocus?: boolean;
    validationRequired?: string | boolean;
    validationCustom?: string | false;
};

export default function PropertyEditMultiSelect({
    className,
    value,
    label,
    hint,
    onChange,
    readonly = false,
    disabled = false,
    options,
    allowBlank = false,
    autoFocus,
    validationRequired,
    validationCustom,
}: PropertyEditMultiSelectProps) {
    const handleInput = (val: string[], lbl?: string) => {
        onChange?.(val, lbl);
    };

    const inputId = useRef(generateShortUuid()).current;

    const validationRequiredWithLabel =
        validationRequired === true ? `${label} is required` : validationRequired;

    if (readonly) {
        return (
            <PropertyDisplay
                className={className}
                label={label}
                hint={hint}
                value={value}
                options={options}
            />
        );
    }
    return (
        <PropertyEdit
            className={coalesceClassNames('PropertyEditMultiSelect__Input', className)}
            label={label}
            hint={hint}
            inputId={inputId}
        >
            <MyMultiSelectInput
                className="PropertyEditMultiSelect__Input--MultiSelect"
                id={inputId}
                value={value}
                options={options}
                disabled={disabled}
                allowBlank={allowBlank}
                handleInput={handleInput}
                autoFocus={autoFocus}
                validationRequired={validationRequiredWithLabel}
                validationCustom={validationCustom}
            />
        </PropertyEdit>
    );
}
